/**
 * Key Points Viewport Tracker
 * PROFCORE-32128
 *
 * Fires window.wmdPageLink('ai-search_kpt-vw') exactly once when the
 * Key Points block's top crosses the 50% viewport height line.
 *
 * Uses IntersectionObserver with rootMargin set to position the trigger
 * line at 50% of the viewport height.
 */

var _observer = null;
var _fired    = false;

/**
 * Returns true if the element is visible in the DOM
 * (not hidden via display:none or visibility:hidden, and has non-zero dimensions).
 * @param {Element} el
 * @returns {boolean}
 */
function isVisible(el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
}

/**
 * Fires the analytics tag once and disconnects the observer.
 */
function fireTag() {
    if (_fired) {
        return;
    }
    _fired = true;

    if (typeof window.wmdPageLink === 'function') {
        window.wmdPageLink('ai-search_kpt-vw');
    }

    destroy();
}

/**
 * Starts observing the Key Points block for 50% viewport visibility.
 * @param {Object} options
 * @param {string} [options.selector='#key-points-card'] - CSS selector for the Key Points block
 */
function init(options) {
    var selector = (options && options.selector) ? options.selector : '#key-points-card';
    var el = document.querySelector(selector);

    if (!el) {
        return;
    }

    if (!isVisible(el)) {
        return;
    }

    // Reset state for fresh init
    _fired = false;

    // rootMargin '-50% 0px -50% 0px' positions a virtual trigger line at 50%
    // of the viewport height. The observer fires when the element enters that zone.
    _observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting && isVisible(el)) {
                fireTag();
            }
        });
    }, {
        root: null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
    });

    _observer.observe(el);
}

/**
 * Disconnects the IntersectionObserver and resets module state.
 */
function destroy() {
    if (_observer) {
        _observer.disconnect();
        _observer = null;
    }
}

module.exports = {
    init:    init,
    destroy: destroy
};
